<template>

  <div class="py-4 container-fluid">
    <div class="row">

      <div class="col-md-8">
        <div class="card mb-2">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="mb-0 section-title">CREAR PRODUCTO</p>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-8">
                <label for="example-text-input" class="form-control-label">Nombre</label>
                <argon-input type="text" v-model="form.name" />
              </div>

              <div class="col-md-4">
                <label for="example-text-input" class="form-control-label">Referencia</label>
                <argon-input type="text" v-model="form.ref" />
              </div>

              <div class="col-md-12">
                <label for="example-text-input" class="form-control-label">Descripción</label>
                <argon-textarea type="text" v-model="form.description" />
              </div>

              <div class="col-md-12">
                <label for="processes-checkbox-list" class="form-control-label">Procesos</label>
                <div id="processes-checkbox-list" class="checkbox-grid" v-if="Array.isArray(form.processes)">
                  <div v-for="process in processes" :key="process.id">
                    <argon-checkbox :id="'process-' + process.id" :value="process.id"
                      :checked="form.processes.includes(process.id)" v-model="form.processes">
                      {{ process.name }}
                    </argon-checkbox>
                  </div>

                </div>
              </div>


              <div class="col-md-4">
                <label for="example-text-input" class="form-control-label">Stock</label>
                <argon-input type="text" v-model="form.quantity" />
              </div>

              <div class="col-md-4">
                <label for="example-text-input" class="form-control-label">Precio de compra</label>
                <argon-input type="text" v-model="form.price" />
              </div>


              <div class="col-md-4">
                <label for="example-text-input" class="form-control-label">Precio de venta</label>
                <argon-input type="text" v-model="form.sale_price" />
              </div>

              <div class="col-12">
                <div class="stock-semaphore-card card border shadow-none mb-3">
                  <div class="card-body py-3">
                    <p class="stock-semaphore-hint text-sm text-secondary mb-3">
                      Los umbrales siguientes definen el <strong>semáforo de stock</strong>: según la cantidad disponible, el inventario se mostrará en rojo, amarillo o verde.
                    </p>
                    <div class="row">
                      <div class="col-md-4">
                        <label for="alert-low" class="form-control-label stock-semaphore-label">
                          <span class="stock-semaphore-dot stock-semaphore-dot--red" aria-hidden="true"></span>
                          Alerta cant. mínima
                        </label>
                        <argon-input id="alert-low" type="text" v-model="form.low" />
                      </div>
                      <div class="col-md-4">
                        <label for="alert-medium" class="form-control-label stock-semaphore-label">
                          <span class="stock-semaphore-dot stock-semaphore-dot--yellow" aria-hidden="true"></span>
                          Alerta cant. media
                        </label>
                        <argon-input id="alert-medium" type="text" v-model="form.medium" />
                      </div>
                      <div class="col-md-4">
                        <label for="alert-high" class="form-control-label stock-semaphore-label">
                          <span class="stock-semaphore-dot stock-semaphore-dot--green" aria-hidden="true"></span>
                          Alerta cant. alta
                        </label>
                        <argon-input id="alert-high" type="text" v-model="form.high" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-6 mb-2">
                <label for="example-text-input" class="form-control-label">Bodega</label>
                <select name="" id="" class="form-select" v-model="form.bodega_id">
                  <option value="">Seleccionar</option>
                  <option v-for="bodega in bodegas" :key="bodega.id" :value="bodega.id">
                    {{ bodega.name }}
                  </option>
                </select>
              </div>

              <div class="col-md-6 mb-2">
                <label for="example-text-input" class="form-control-label">Estado</label>
                <select name="" id="" class="form-select" v-model="form.status">
                  <option value="0">Inactivo</option>
                  <option value="1">Activo</option>
                </select>
              </div>

              <hr class="horizontal dark my-3" />

              <div class="col-12 mb-2">
                <p class="text-sm text-secondary mb-0">
                  <strong>Observación:</strong> Al pasar el modelo a primera, segunda, tercera o a cualquiera de las averías (cargue, descargue, crudo, secado, despacho), las opciones seleccionadas en los códigos siguientes son a las que se les asignará la cantidad.
                </p>
              </div>

              <!-- Campo Primera -->
              <div class="col-md-4">
                <label for="codigo_primera" class="form-control-label">Código primera</label>
                <select ref="codigo_primera" id="codigo_primera" class="form-select select2" style="width:100%;">
                </select>
              </div>

              <!-- Campo Segunda -->
              <div class="col-md-4">
                <label for="codigo_segunda" class="form-control-label">Código segunda</label>
                <select ref="codigo_segunda" id="codigo_segunda" class="form-select select2" style="width:100%;">
                </select>
              </div>

              <!-- Campo Tercera -->
              <div class="col-md-4">
                <label for="codigo_tercera" class="form-control-label">Código tercera</label>
                <select ref="codigo_tercera" id="codigo_tercera" class="form-select select2" style="width:100%;">
                </select>
              </div>

              <!-- Campo Avería Cargue -->
              <div class="col-md-4">
                <label for="codigo_averia_cargue" class="form-control-label">Código avería cargue</label>
                <select name="codigo_averia_cargue" id="codigo_averia_cargue" class="form-select select2"
                  style="width:100%;">
                </select>
              </div>

              <!-- Campo Avería Descargue -->
              <div class="col-md-4">
                <label for="codigo_averia_descargue" class="form-control-label">Código avería descargue</label>
                <select name="codigo_averia_descargue" id="codigo_averia_descargue" class="form-select select2"
                  style="width:100%;">
                </select>
              </div>

              <!-- Campo Avería Crudo -->
              <div class="col-md-4">
                <label for="codigo_averia_crudo" class="form-control-label">Código avería crudo</label>
                <select name="codigo_averia_crudo" id="codigo_averia_crudo" class="form-select select2"
                  style="width:100%;">
                </select>
              </div>

              <!-- Campo Avería Secado -->
              <div class="col-md-4">
                <label for="codigo_averia_secado" class="form-control-label">Código avería secado</label>
                <select name="codigo_averia_secado" id="codigo_averia_secado" class="form-select select2"
                  style="width:100%;">
                </select>
              </div>

              <!-- Campo Avería Despacho -->
              <div class="col-md-4">
                <label for="codigo_averia_despacho" class="form-control-label">Código avería despacho</label>
                <select name="codigo_averia_despacho" id="codigo_averia_despacho" class="form-select select2"
                  style="width:100%;">
                </select>
              </div>

              <div class="col-md-4 d-flex align-items-end justify-content-end">
                <argon-button color="warning" size="sm" @click="save">Guardar</argon-button>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="col-12" v-if="form.id != 0">
        <div class="card">

          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <h6 class="mb-0 section-title">LISTA DE NOVEDADES</h6>
              <argon-button color="warning" size="sm" class="ms-auto" @click="openModal">Agregar
                novedad</argon-button>
            </div>
          </div>

          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">

              <table class="table align-items-center mb-0 novelties-table">
                <thead>
                  <tr>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Cantidad</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Observación
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Fecha de creación
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Opciones
                    </th>

                  </tr>
                </thead>
                <tbody>
                  <tr v-for="value in data" :key="value.id">

                    <!-- Cantidad -->
                    <td class="align-middle text-center text-sm">
                      {{ value.quantity_change }}
                    </td>

                    <!-- Observación -->
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">
                        <a @click="viewObservation(value.observation)"
                          class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                          data-original-title="Registro">
                          <i class="fa fa-comment"></i>
                        </a>
                      </span>
                    </td>

                    <!-- created_at -->
                    <td class="align-middle text-center text-sm">
                      <div class="d-flex justify-content-center">
                        <h6 class="mb-0 text-sm">
                          {{ new Date(value.created_at).toLocaleDateString('es-ES') }}
                        </h6>
                      </div>
                    </td>

                    <!-- opciones -->
                    <td class="align-middle text-center">

                      <!-- Editar -->
                      <a @click="editRegister(value)" class="text-secondary font-weight-bold text-xs cursor-pointer"
                        data-toggle="tooltip" data-original-title="Editar registro">
                        <i class="fa fa-pencil-alt"></i>
                      </a>

                      <!-- Eliminar -->
                      <a @click="deleteRegister(value.id)"
                        class="text-secondary font-weight-bold text-xs cursor-pointer" style="margin-left: 15px;"
                        data-toggle="tooltip" data-original-title="Eliminar registro">
                        <i class="fa fa-trash"></i>
                      </a>

                    </td>
                  </tr>

                  <tr v-if="data.length === 0">
                    <td colspan="7" class="text-center text-xxs">No hay registros disponibles</td>
                  </tr>

                </tbody>
              </table>

              <!-- Paginación -->
              <div class="pagination p-3">
                <!-- Recorremos los links para generar los botones -->
                <a v-for="link in links" :key="link.label" class="page-item cursor-pointer"
                  @click="fetchData(link.label)" :disabled="!link.url || link.active"
                  :class="{ 'active': link.label === currentPage.toString() }">
                  {{ link.label }}
                </a>
              </div>

            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- Modal -->
    <div class="modal fade" id="ModalBudget" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <span class="section-title" id="exampleModalLabel">Agregar novedad</span>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form>

              <div class="mb-3">
                <label for="amount" class="form-control-label">Cantidad</label>
                <input type="number" v-model="modal.quantity_change" id="total_price" class="form-control"
                  placeholder="Ingrese el valor total">
              </div>

              <div class="mb-3">
                <label for="observation" class="form-control-label">Observación</label>
                <textarea v-model="modal.observation" id="observation" class="form-control"
                  placeholder="Ingrese la observación"></textarea>
              </div>

            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModal">Cerrar</button>
            <button type="button" class="btn btn-primary" @click="submitForm">Guardar</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->

  </div>

</template>


<style scoped>
.section-title {
  font-weight: 800;
  color: #1f2d5a;
  letter-spacing: 0.6px;
}

.section-title::after {
  content: "";
  display: block;
  width: 44px;
  height: 3px;
  margin-top: 6px;
  border-radius: 999px;
  background: #f6a500;
}

/* Título del modal: mismo color y línea amarilla que el resto */
.modal-header .section-title {
  font-weight: 800;
  color: #1f2d5a !important;
  letter-spacing: 0.6px;
}
.modal-header .section-title::after {
  content: "";
  display: block;
  width: 44px;
  height: 3px;
  margin-top: 6px;
  border-radius: 999px;
  background: #f6a500;
}

/* Make "Lista de novedades" table a bit more compact horizontally */
.novelties-table {
  width: 92% !important;
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
}

.novelties-table th,
.novelties-table td {
  padding-left: 0.6rem !important;
  padding-right: 0.6rem !important;
}

.checkbox-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  /* Dos columnas iguales */
}

.stock-semaphore-card {
  border-color: #dee2e6 !important;
  background-color: #fafbfc;
}

.stock-semaphore-hint {
  line-height: 1.45;
}

.stock-semaphore-label {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.stock-semaphore-dot {
  flex-shrink: 0;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.08);
}

.stock-semaphore-dot--red {
  background-color: #e53935;
}

.stock-semaphore-dot--yellow {
  background-color: #f9b002;
}

.stock-semaphore-dot--green {
  background-color: #43a047;
}
</style>

<script>
import setNavPills from "../../../assets/js/nav-pills.js";
import setTooltip from "../../../assets/js/tooltip.js";
import ArgonInput from "../../../components/ArgonInput.vue";
import ArgonTextarea from "../../../components/ArgonTextarea.vue";
import ArgonButton from "../../../components/ArgonButton.vue";
import ArgonCheckbox from "../../../components/ArgonCheckbox.vue";

import { useRoute } from "vue-router";
import Swal from 'sweetalert2';
import 'select2/dist/css/select2.css';
import 'select2';
import { Modal } from 'bootstrap';
import { mapGetters } from 'vuex';

import $ from 'jquery';

const body = document.getElementsByTagName("body")[0];

export default {
  name: "Models Create",
  data() {
    return {
      showMenu: false,
      form: {
        id: 0,
        name: '',
        ref: '',
        description: '',
        quantity: 0,
        status: 1,
        bodega_id: 0,
        price: 0,
        sale_price: 0,
        low: 0,
        medium: 0,
        high: 0,
        processes: [],
        primera: '',
        segunda: '',
        tercera: '',
        averia_cargue: '',
        averia_descargue: '',
        averia_crudo: '',
        averia_secado: '',
        averia_despacho: ''
      },
      processes: [],
      modal: {
        id: 0,
        inventory_id: 0,
        quantity_change: 0,
        observation: '',
      },
      bodegas: [],
      users: [],
    };
  },
  components: { ArgonInput, ArgonTextarea, ArgonButton, ArgonCheckbox },
  computed: {
    ...mapGetters('inventoryNews', ['allData', 'currentPage', 'lastPage', 'pagination', 'links']), // Mapea el getter allUsers
    currentPage() {
      return this.$store.state.inventoryNews.currentPage; // Obtiene la página actual
    },
    lastPage() {
      return this.$store.state.inventoryNews.lastPage; // Obtiene la última página
    },
    data() {
      return this.allData; // Retorna los usuarios desde el store
    },
    links() {
      return this.$store.getters['inventoryNews/links']; // Retorna los links
    },
  },
  methods: {


    async getModels() {
      try {
        this.models = await this.$store.dispatch('inventory/getAll');

        // Lista de todos los selects que necesitan ser inicializados con Select2
        const selectsToInitialize = [
          { id: 'codigo_primera', formProperty: 'primera' },
          { id: 'codigo_segunda', formProperty: 'segunda' },
          { id: 'codigo_tercera', formProperty: 'tercera' },
          { id: 'codigo_averia_cargue', formProperty: 'averia_cargue' },
          { id: 'codigo_averia_descargue', formProperty: 'averia_descargue' }, // Nota: El id en tu HTML es 'descague'
          { id: 'codigo_averia_crudo', formProperty: 'averia_crudo' },
          { id: 'codigo_averia_secado', formProperty: 'averia_secado' },
          { id: 'codigo_averia_despacho', formProperty: 'averia_despacho' }
        ];

        // Función auxiliar para inicializar un select
        const initializeSelect = (config) => {
          const $select = $(`#${config.id}`); // Usamos el ID para seleccionar el elemento

          // Si el elemento no existe en el DOM, no hacemos nada.
          if (!$select.length) {
            console.warn(`El elemento select con id #${config.id} no fue encontrado.`);
            return;
          }

          // Destruir instancia previa de Select2 si existe
          if ($select.data('select2')) {
            $select.select2('destroy');
          }

          // Limpiar y agregar las opciones dinámicamente
          $select.empty().append('<option value="">Seleccionar...</option>');
          this.models.forEach(model => {
            $select.append(new Option( model.ref +' - '+model.name, model.ref));
          });

          // Inicializar Select2
          $select.select2({
            placeholder: 'Seleccionar...',
            allowClear: true,
          }).on('change', () => {
            // Actualizar la propiedad correspondiente en el formulario
            this.form[config.formProperty] = $select.val();
          });

          // Si hay un valor pre-seleccionado en el formulario, lo establecemos
          if (this.form[config.formProperty]) {
            $select.val(this.form[config.formProperty]).trigger('change');
          }
        };

        // Recorremos la lista e inicializamos cada select
        selectsToInitialize.forEach(config => {
          initializeSelect(config);
        });

      } catch (error) {
        console.error('Error al obtener y configurar los modelos:', error);
      }
    },

    async getOficios() {
      this.processes = await this.$store.dispatch('users/getOficios');
      console.log('this.processes', this.processes);
    },
    async fetchData(pageUrl = null) {

      const params = {
        inventory_id: this.form.id,
        page: pageUrl
      };
      await this.$store.dispatch('inventoryNews/fetchData', params);
    },
    async getBodegas() {
      this.bodegas = await this.$store.dispatch('bodegas/getAll');
    },
    async save() {
      try {
        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("inventory/save", this.form);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El proyecto ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {
              this.$router.push({ name: "Supplies" });
            }
          });

        } else {
          throw new Error(response.data.message || 'Error al guardar el proyecto');
        }

      } catch (error) {
        console.error("Error al crear el proyecto:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el proyecto',
        });
      }
    },
    openModal() {
      const modalElement = document.getElementById('ModalBudget');
      this.modalBudget = new Modal(modalElement); // Guarda la instancia del modal
      this.modalBudget.show(); // Muestra el modal
    },
    closeModal() {
      if (this.modalBudget) {
        this.modalBudget.hide(); // Cierra el modal
      }
    },
    async submitForm() {
      try {
        this.modal.inventory_id = this.form.id;
        // Dispara la acción de Vuex para guardar el modal
        const response = await this.$store.dispatch("inventoryNews/save", this.modal);

        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {
              this.modal.quantity_change = 0;
              this.modal.observation = '';

              //console.log(response);
              this.form.quantity = parseFloat(response.data.data.stock) || 0;

              this.closeModal();
              this.fetchData();
            }
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }

      } catch (error) {
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }

    },
    async editRegister(data) {
      this.modal = data;
      this.openModal();
    },
    async deleteRegister(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("inventoryNews/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {

            await Swal.fire(
              'Eliminado!',
              'El registro ha sido eliminado correctamente.',
              'success'
            );

            this.fetchData();
          } else {
            throw new Error(response.data.message || 'Error al eliminar el registro');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
    viewObservation(observation) {
      // Mostramos el mensaje en un SweetAlert
      Swal.fire({
        title: 'Observación',
        text: observation || 'No hay observaciones disponibles.',
        icon: 'info',  // Puedes cambiar el icono a info, success, warning, etc.
        confirmButtonText: 'Aceptar'
      });
    },

  },
  mounted() {

    this.getModels();

    this.getBodegas();

    this.getOficios();


    const route = useRoute();
    const dataEdit = route.params.data;

    console.log(dataEdit);

    if (dataEdit) {
      try {
        const params = JSON.parse(dataEdit); // Asegúrate de que este JSON se pueda parsear


        if (params && params.id) {

          this.form = params;

          console.log(this.form);
          this.fetchData();

        }
      } catch (error) {
        console.error("Error al parsear los datos del registro:", error);
      }
    }

    this.$store.state.isAbsolute = false;
    setNavPills();
    setTooltip();
  },
  beforeMount() {
    this.$store.state.imageLayout = "profile-overview";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = true;
    body.classList.add("profile-overview");
  },
  beforeUnmount() {
    this.$store.state.isAbsolute = false;
    this.$store.state.imageLayout = "default";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = false;
    body.classList.remove("profile-overview");
  }
};
</script>

<style>
.disabled-link {
  color: gray;
  pointer-events: none;
  /* Impide la interacción */
  cursor: not-allowed;
  /* Cambia el cursor para indicar que está deshabilitado */
}

.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.page-item {
  margin: 0 5px;
}

.active {
  font-weight: bold;
  /* Estilo para la página activa */
}
</style>
